/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  PutUserRequestsIdMutationRequest,
  PutUserRequestsIdMutationResponse,
  PutUserRequestsIdPathParams,
  PutUserRequestsId400,
} from '../entities/PutUserRequestsId'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getPutUserRequestsIdUrl(id: PutUserRequestsIdPathParams['id']) {
  return `/user-requests/${id}` as const
}

/**
 * @description Обновление заявки водителя таксопарка
 * @summary Обновление заявки водителя таксопарка
 * {@link /user-requests/:id}
 */
export async function putUserRequestsId(
  id: PutUserRequestsIdPathParams['id'],
  data: PutUserRequestsIdMutationRequest,
  config: Partial<RequestConfig<PutUserRequestsIdMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<PutUserRequestsIdMutationResponse, ResponseErrorConfig<PutUserRequestsId400>, PutUserRequestsIdMutationRequest>({
    method: 'PUT',
    url: getPutUserRequestsIdUrl(id).toString(),
    data,
    ...requestConfig,
  })
  return res.data
}